import { Form } from '@/components';
import { useTranslation } from 'react-i18next';
import { useReportingClientLookupSource } from '@/views';

interface Props {
  name: string;
  mode?: 'multiple';
  required?: boolean;
}

export function ReportingClientSelect(props: Props) {
  const { name, mode, required } = props;
  const clientsDataSource = useReportingClientLookupSource(null);
  const { t } = useTranslation();

  return (
    <Form.AsyncSelect
      name={name}
      dataSource={clientsDataSource}
      mode={mode}
      maxTagCount={2}
      maxTagTextLength={10}
      required={required}
      selectAll={{
        selectAllLabel: t('reports.homeStatus.selectAll'),
        unselectAllLabel: t('reports.homeStatus.unselectAll'),
      }}
    />
  );
}
